import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './selling-offers-banner.module.scss';

const SellingOffersBanner: React.FC = () => {
  const { t } = useTranslation('negotiation');

  return (
    <div className={styles.sellingOffers__banner}>
      <p className="vc-text-H14">
        <span className={styles.sellingOffers__banner__new}>
          {t('NEGOTIATION_LISTING.SELLING_OFFERS.BANNER_TITLE')}
        </span>
        {t('NEGOTIATION_LISTING.SELLING_OFFERS.BANNER_DESCRIPTION')}
      </p>
    </div>
  );
};

export default SellingOffersBanner;
